import { Reactor } from 'nuclear-js'
import { customerStore } from './stores/customer-store'
import { userStore } from './stores/user-store'
import { geoStore } from './stores/geo-store'
import { environment } from './environments/environment'

const debug = (environment.env === 'development')

export const reactor = new Reactor({ debug })

reactor.registerStores({
  user: userStore,
  customer: customerStore,
  geo: geoStore
})

